import { Grid } from "@mui/material";
import { MdmFormProps } from "../../../Forms/MdmFormProps";
import { EdcCoordinatesForm } from "./EdcCoordinatesForm";
import { EdcGsdbForm } from "./EdcGsdbForm";
import { EdcAddressForm } from "./EdcAddressForm";

export const EdcForm = ({ disabledFields }: MdmFormProps) => {
  return (
    <Grid container columnSpacing={1}>
      <Grid item xs={12}>
        <EdcGsdbForm disabledFields={disabledFields} />
      </Grid>
      <Grid item xs={9}>
        <EdcAddressForm disabledFields={disabledFields} />
      </Grid>
      <Grid item xs={3}>
        <EdcCoordinatesForm disabledFields={disabledFields} />
      </Grid>
    </Grid>
  );
};
